import {
  AnalyticsEvents,
  useAnalytics,
  useAnalyticsDefaultValues,
} from '@src/providers/analytics';
import { useEffect } from 'react';
import { Text, VStack } from 'ui_2';

type Props = {
  logoURL: string;
  textColor?: 'dark' | 'light';
  service: string;
};
export const SponsoredBy = ({
  logoURL,
  textColor = 'dark',
  service,
}: Props) => {
  const analytics = useAnalytics();
  const { address, network, partBalance } = useAnalyticsDefaultValues();

  return (
    <div className='flex w-full flex-col items-center justify-center gap-2 py-2 md:flex-row md:gap-4'>
      <Text font='xs' color={textColor === 'dark' ? 'black' : 'white'}>
        Sponsored by
      </Text>
      <img
        src={logoURL}
        className='h-[31px]'
        alt={'Aleo Logo'}
        onLoad={() => {
          analytics.track(AnalyticsEvents.AdBannerViewed, {
            address,
            network,
            partBalance,
            service,
          });
        }}
      />
    </div>
  );
};
